// controllers/useHomeController.js
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { getPersistentUserId } from '@api/userService.js';
import { logDev } from '@utils/logDev.js';

export function useHomeController() {
    const [reconnectData, setReconnectData] = useState(null);
    const [showKickModal, setShowKickModal] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { wasKicked, reason } = location.state || {};

    useEffect(() => {
        setShowKickModal(wasKicked);

        const checkReconnect = async () => {
            const persistentId = getPersistentUserId();
            try {
                logDev('Persistent ID:', persistentId);
                const response = await axios.get(`/api/active-lobby/${persistentId}`);
                if (response.data.hasActiveLobby) {
                    logDev(response.data);
                    setReconnectData(response.data);
                }
            } catch (err) {
                logDev('Reconnect-Check fehlgeschlagen:', err);
            }
        };

        checkReconnect();
    }, [wasKicked]);

    const handleReconnect = () => {
        if (!reconnectData) return;
        const path = reconnectData.isInGame
            ? `/game/${reconnectData.gameType}/${reconnectData.lobbyCode}`
            : `/lobby/${reconnectData.lobbyCode}`;
        navigate(path);
    };

    return {
        reconnectData,
        showKickModal,
        setShowKickModal,
        reason,
        handleReconnect,
        navigate
    };
}
